// Pro's checkout from /pricing (OpenConceptLab/ocl_online#325). online-api's GET /billing/plan/
// gives the signed-in account its one billing action: the store's checkout, carrying the username,
// for Community; the subscription's portal for Pro bought there; none for a plan OCL set up by hand.
// The contract: ocl-online-docs launch/nov1/driver/seeds/pass1-contract.md.
// No imports beyond utils.js, so the unit tests run in bare Node.
import { getAPIURL } from './utils.js';

// online-api for the OCL API this site signs in to. A token only works in its own environment, so
// any other API (a local one, say) has none, and the Pro buttons can't reach checkout.
export const ONLINE_API_URLS = {
  'https://api.openconceptlab.org': 'https://online-api.openconceptlab.org',
  'https://api.staging.openconceptlab.org': 'https://online-api.staging.openconceptlab.org',
};

export const onlineAPIURL = (apiURL = getAPIURL()) => ONLINE_API_URLS[apiURL] || null;

const isAction = action => Boolean(action?.label && /^https:\/\//.test(action.url || ''));

// Resolves to {plan, action}, or null when online-api can't be asked. `action` is null for a plan
// OCL set up by hand, and for Community when no checkout is configured.
export const fetchPlanAction = (token, lang, { apiURL, fetchImpl = globalThis.fetch } = {}) => {
  const base = onlineAPIURL(apiURL);
  if (!base || !token)
    return Promise.resolve(null);
  const query = new URLSearchParams({ context: 'pricing', lang });
  return fetchImpl(`${base}/billing/plan/?${query}`, { headers: { Authorization: `Token ${token}`, Accept: 'application/json' } })
    .then(response => (response.ok ? response.json() : null))
    .then(record => (record && typeof record === 'object' ? { plan: record.plan, action: isAction(record.action) ? record.action : null } : null))
    .catch(() => null);
};

// Signed out, a Pro button starts sign-in and the visitor comes back to /pricing. This marks the
// round trip so the page continues to checkout, once, in this tab.
const INTENT_KEY = 'checkoutAfterSignIn';
export const rememberCheckoutIntent = () => sessionStorage.setItem(INTENT_KEY, 'pro');
export const consumeCheckoutIntent = () => {
  const intent = sessionStorage.getItem(INTENT_KEY);
  sessionStorage.removeItem(INTENT_KEY);
  return intent === 'pro';
};
